import { render } from "./TkEngagements.vue?vue&type=template&id=f5aacfe0"
import script from "./TkEngagements.vue?vue&type=script&lang=js"
export * from "./TkEngagements.vue?vue&type=script&lang=js"

import "../assets/styles/tkEngagements.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QRouteTab});
